import Papa from "papaparse";

const createCSVFile = (data) => {
  const unparsed = Papa.unparse(data);

  const csvFile = new Blob([unparsed], { type: "text/csv;charset=utf-8" });

  return csvFile;
};

const downloadCSVFile = (csvFile, filename) => {
  const url = URL.createObjectURL(csvFile);
  const link = document.createElement("a");
  link.download = `${filename}.csv`;
  link.href = url;
  link.click();
};

const parseCsv = async (csvFile, onParseComplete = () => {}, onParseError = () => {}) => {
  Papa.parse(csvFile, {
    header: true,
    skipEmptyLines: true,
    complete: onParseComplete,
    error: onParseError
  });
};

const parseCsvAsText = async (csvFile) => {
  const url = URL.createObjectURL(csvFile);

  return fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      return responseText;
    });
};

const csvUtil = { createCSVFile, downloadCSVFile, parseCsv, parseCsvAsText };

export default csvUtil;
